<template>
  <div>
    <el-dialog title="查询历史结果" :visible.sync="historyDV" width="1200px" :before-close="closeHistoryDV"
      class="history-DV">
      <div class="table-DV">
        <el-table :data="rowTableDataList" border style="width: 100%">
          <el-table-column header-align="center" prop="queryTime" label="查询时间" width="100"></el-table-column>
          <el-table-column header-align="center" prop="profileId" label="Profile ID" width="130">
          </el-table-column>
          <el-table-column header-align="center" prop="scoreRankingDetail" label="账号安全等级" width="130">
          </el-table-column>
          <el-table-column align="center" label="黑名单">
            <template slot-scope="{ row }">
              {{ row.blacklistFlag ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="accountQueryCount" label="被查次数">
          </el-table-column>
          <el-table-column header-align="center" prop="accountName" label="姓名" width="130"></el-table-column>
          <el-table-column align="center" prop="topRanking" label="TOP买家"></el-table-column>
          <el-table-column prop="halloffameFlag" align="center" label="名人堂">
            <template slot-scope="{ row }">
              {{ row.halloffameFlag ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="vinevoiceFlag" label="Vine标">
            <template slot-scope="{ row }">
              {{ row.vinevoiceFlag ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="noShare" align="center" label="Profile是否隐藏">
            <template slot-scope="{ row }">
              {{ row.noShare == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="totalHelpfulVotes" label="总投票数">
          </el-table-column>
          <el-table-column align="center" prop="reviewerRankingDetail" label="账号排名" width="100"></el-table-column>
          <el-table-column align="center" prop="accountMonths" label="账号年限" width="100">
          </el-table-column>
          <el-table-column align="center" prop="reviewDeletionNumber" label="留评被删数" width="100">
          </el-table-column>
          <el-table-column header-align="center" prop="reviewDeletionRankingDetail" label="留评被删评估" width="140">
          </el-table-column>
          <el-table-column align="center" prop="verifiedNoPurchaseReviewPercent" label="非认证购买比例" width="130">
          </el-table-column>
          <el-table-column align="center" prop="totalCriticalReviews" label="给过差评数" width="95">
          </el-table-column>
          <el-table-column header-align="center" prop="criticalReviewsRankingDetail" label="差评风险评估" width="140">
          </el-table-column>
          <el-table-column header-align="center" prop="reviewPremiumcontentRankingDetail" label="优质评价概率" width="140">
          </el-table-column>
          <el-table-column align="center" prop="averageHelpfulVotesRatio" label="均投票数" width="100"></el-table-column>
          <el-table-column header-align="center" prop="averageHelpfulVotesRankingDetail" label="均投票数排名" width="140">
          </el-table-column>
          <el-table-column align="center" prop="activeIndex" label="活跃指数"></el-table-column>
          <el-table-column align="center" prop="latest6monthActualReviewsDetail" label="近六个月留评数" width="130">
          </el-table-column>
          <el-table-column align="center" prop="latest6monthReviewsPercent" label="近六个月留评比例" width="140">
          </el-table-column>
          <el-table-column header-align="center" prop="latest6monthReviewsRankingDetail" label="近六个月留评排名" width="140">
          </el-table-column>
          <el-table-column align="center" prop="latest1yearActualReviews" label="近一年留评数" width="130"></el-table-column>
          <el-table-column align="center" prop="latest1yearReviewsPercent" label="近一年留评比例" width="130">
          </el-table-column>
          <el-table-column header-align="center" prop="latest1yearReviewsRankingDetail" label="近一年留评排名" width="140">
          </el-table-column>
          <el-table-column align="center" prop="totalReview" label="全部留评数" width="100"></el-table-column>
          <el-table-column align="center" prop="totalReviewPercent" label="全部留评比例" width="105"></el-table-column>
          <el-table-column header-align="center" prop="totalReviewRankingDetail" label="全部留评排名" width="140">
          </el-table-column>
          <el-table-column align="center" prop="latest1yearReviewStarDetail" label="近一年留评星级分布" width="130">
            <template slot-scope="{ row }">
              {{ latest1(row.latest1yearReviewStarDetail) }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="totalReviewStarDetail" label="总留评星级分布" width="130">
            <template slot-scope="{ row }">
              {{ total(row.totalReviewStarDetail) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeHistoryDV">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'rowTableData',
  props: {
    historyDV: {
      type: Boolean,
      default: false
    },
    rowTableDataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },

  mounted() { },

  methods: {
    closeHistoryDV() {
      this.$emit('closeHistoryDV')
    },
    latest1(row) {
      return (
        '实际评论个数:' +
        row.totalActualReviews +
        '实际好评个数:' +
        row.totalPositiveReviews +
        '实际差评个数:' +
        row.totalCriticalReviews
      )
    },
    total(row) {
      return (
        '实际评论个数:' +
        row.totalActualReviews +
        '实际好评个数:' +
        row.totalPositiveReviews +
        '实际差评个数:' +
        row.totalCriticalReviews
      )
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-button {
  background-color: #3c7cff;
  border-color: #3777ff;
  color: #fff;
}
</style>
